"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var StorageService = (function () {
    function StorageService() {
        this.storageErrorMessage = 'Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.';
    }
    StorageService.prototype.save = function (property, data) {
        try {
            localStorage.setItem(property, JSON.stringify(data));
        }
        catch (error) {
            alert(this.storageErrorMessage);
        }
    };
    StorageService.prototype.saveString = function (property, stringItem) {
        try {
            localStorage.setItem(property, stringItem);
        }
        catch (error) {
            alert(this.storageErrorMessage);
        }
    };
    StorageService.prototype.get = function (property) {
        return localStorage.getItem(property);
    };
    StorageService.prototype.getArray = function (property) {
        try {
            return JSON.parse(localStorage.getItem(property));
        }
        catch (error) {
            return [];
        }
    };
    StorageService.prototype.getObject = function (property) {
        try {
            return JSON.parse(localStorage.getItem(property));
        }
        catch (error) {
            return {};
        }
    };
    StorageService.prototype.clear = function () {
        localStorage.clear();
    };
    StorageService.prototype.remove = function (item) {
        localStorage.removeItem(item);
    };
    StorageService.prototype.getStorage = function () {
        return localStorage;
    };
    return StorageService;
}());
StorageService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], StorageService);
exports.StorageService = StorageService;



//////////////////
// WEBPACK FOOTER
// ./src/services/storage.service.ts
// module id = 69
// module chunks = 0